import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDateString } from "./fulfillment-group-csv-utils";

export const SLADeliveryPromiseCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "SLA delivery promise",
    cell: (row) => {
      return formatDateString(row?.slaFulfillmentDate?.toISOString());
    },
  };
